export default __webpack_public_path__ + "static/media/icon-copy_url-highlighted.7b67055d.svg";